import React from 'react';
import PropTypes from 'prop-types';
import Field from './FieldValue';

import './TextareaField.scss';



export default function TextareaField({ style, label, value, placeholder = '', onChange, error, count, max, name }) {
  let foot = null;
  if (count) {
    if (max) {
      foot = `${value.length}/${max}`;
    } else {
      foot = value.length;
    }
  }
  return (
    <Field
      style={style}
      className="form-textarea-field"
      label={label}
      error={error}
      footnote={foot}
    >
      <textarea
        placeholder={placeholder}
        value={value}
        name ={name}
        onChange={max ? (evt) => {
          if (evt.target.value.length > max) {
            evt.preventDefault();
            onChange({
              target: {
                value: evt.target.value.substring(0, max),
              },
            });
          } else {
            onChange(evt);
          }
        } : onChange}
      />
    </Field>
  );
}

TextareaField.propTypes = {
  style: PropTypes.shape(),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
  count: PropTypes.bool,
  max: PropTypes.number,
};

TextareaField.defaultProps = {
  style: {},
  placeholder: '',
  label: '',
  value: '',
  error: null,
  count: false,
  max: 0,
};
